import { useState } from "react";
import electionKeys from "../../constants/electionKeys"

const ExitPoll = () => {
  const [isRegionalTab, setIsRegionalTab] = useState(false);
  const showExitPoll = electionKeys.showExitPoll;

  return (
    <>{ 
    showExitPoll?<div className="px-6 my-2">
    <div className="flex items-center h-full">
        <div className="h-3 w-2 bg-customPoll mr-2"></div>
        <h2 className="font-bold font-devnagri text-2xl">एग्जिट पोल</h2>
    </div>
  <div className="flex gap-4 my-2 border-b-2 border-customPoll">
    <div className="flex">
      <button
        className={`${
          !isRegionalTab
            ? "bg-primary text-white"
            : "bg-blue-100 text-gray-500"
        } font-semibold px-4 py-2 rounded-tr-lg rounded-tl-lg`}
        onClick={() => setIsRegionalTab(false)}
      >
        लोक सभा
      </button>
    </div>
    {/* <hr className="h-1 border-0 bg-#E12725"></hr> */}
  </div>
  <div>
  {(
    <iframe
      title="loksabha exit poll"
      src={`https://electionresults.intoday.in/elections/2024/loksabha-elections/html/exit-poll/lok-sabha-exit-poll.html?site=uptak&theme=1&v=${electionKeys.exitPollVersion}`}
      className="min-h-[360px] w-full scrollbar-none"
      height={360}
    />
  )}
  </div>
</div>:<></>}</>
  );
};

export default ExitPoll;
